
import { Button } from '@/components/ui/button';

interface CtaButtonBlockProps {
  content: {
    buttonText: string;
    buttonLink: string;
    alignment: 'left' | 'center' | 'right';
  };
}

export const CtaButtonBlock = ({ content }: CtaButtonBlockProps) => {
  const { buttonText, buttonLink, alignment } = content;

  if (!buttonText || !buttonLink) return null;

  const alignmentClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }[alignment] || 'text-center';

  return (
    <section className="py-12 px-6">
      <div className={`max-w-4xl mx-auto ${alignmentClass}`}>
        <Button 
          asChild
          size="lg" 
          className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg"
        >
          <a href={buttonLink}>{buttonText}</a>
        </Button>
      </div>
    </section>
  );
};
